import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Button, Form } from "antd";
import { List, Map } from "immutable";
import shortID from "uuid/v4";
import "styles/form.css";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { PD_BANK_DETAILS_TABLE_FIELDS } from "constants/form-fields";
const FormItem = Form.Item;

class PDBrandsTable extends React.Component {
    state = {
        values: [],
        statIds: this.props.products.map((v, k) => k),
        removed_stats: [],
        productStats:
            this.props.products && this.props.products.size
                ? this.props.products
                : new List([]),
        openAddProductModal: false
    };

    componentDidUpdate() {
        if (this.props.products.size > this.state.statIds.size) {
            this.setState({
                statIds: this.props.products.map((v, k) => k),
                removed_stats: []
            });
        }
        if (
            this.props.products &&
            this.props.products.size &&
            this.state.statIds.size &&
            this.props.products.size === this.state.statIds.size &&
            this.props.products.last().Account_Number !== this.state.statIds.last()
        ) {
            this.setState({
                statIds: this.props.products.map((v, k) => k),
                removed_stats: []
            });
        }
    }

    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);

    toggleFormGrid = (action = "ADD", id) => {
        const { statIds } = this.state;
        let removed_stats = this.state.removed_stats;
        const newID = shortID();
        switch (action) {
        case "ADD":
            this.setState({
                statIds: statIds.set(newID, newID)
            });
            break;
        case "REMOVE": {
            removed_stats.push(id);
            this.setState({
                removed_stats: removed_stats
            });
            break;
        }
        default:
        }
    };

    saveStats = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                this.props.updateBrands(values);
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col span={24}>
                        <div className="mb-10">
                            {this.state.statIds && this.state.statIds.size
                                ? this.state.statIds
                                    .toList()
                                    .filter(
                                        _ =>
                                            !this.state.removed_stats
                                                .length ||
                                              !this.state.removed_stats.includes(
                                                  _
                                              )
                                    )
                                    .map(_ => (
                                        <div
                                            key={`Brands-${_}`}
                                            className="form-row form-row-compact bg-grey p-10 br-3"
                                        >
                                            {PD_BANK_DETAILS_TABLE_FIELDS.map(
                                                (field, fieldName) => {
                                                    if (
                                                        fieldName ===
                                                          "channel_product"
                                                    ) {
                                                        field.onSelect = this.onSelectProducts.bind(
                                                            null,
                                                            _
                                                        );
                                                        field.onSearch = this.onSearchProducts;
                                                    }
                                                    if (
                                                        fieldName === "value"
                                                    ) {
                                                        field.addAfter.name = `brands.${_}|brand.${"value_type"}`;
                                                    }
                                                    return this.fieldGenerator(
                                                        `${_}.${fieldName}`,
                                                        field,
                                                        this.getErrorOnField(
                                                            `${_}.${fieldName}`
                                                        )
                                                    )();
                                                }
                                            ).toList()}
                                            <FormItem
                                                className={cx("m-0 form-btn")}
                                            >
                                                <Button
                                                    shape="circle"
                                                    icon={"minus"}
                                                    onClick={this.toggleFormGrid.bind(
                                                        null,
                                                        "REMOVE",
                                                        _
                                                    )}
                                                />
                                            </FormItem>
                                        </div>
                                    ))
                                : null}
                        </div>

                        <div className="form-row d-flex justify-content-space-between">
                            <FormItem className={cx("form-btn m-0")}>
                                <Button
                                    type="dashed"
                                    icon={"plus"}
                                    // disabled={this.props.formDisabled}
                                    onClick={this.toggleFormGrid.bind(
                                        null,
                                        "ADD"
                                    )}
                                >
                                    Add Bank
                                </Button>
                            </FormItem>
                            <FormItem className={cx("m-0")}>
                                <Button
                                    type="primary"
                                    icon={"plus"}
                                    onClick={this.saveStats}
                                >
                                    Save
                                </Button>
                            </FormItem>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

PDBrandsTable.propTypes = {
    form: PropTypes.object,
    products: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    updateBrands: PropTypes.func
};

export default Form.create({
    mapPropsToFields: ({ products }) => {
        let values = products;
        if (values && values.size > 0) {
            return values
                .map(value => {
                    return new Map(value).map(v =>
                        Form.createFormField({
                            value: v
                        })
                    );
                })
                .toJS();
        }
    }
})(PDBrandsTable);
